import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpexplorer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 256C512 397.2 397.3 512 256 512 114.8 512 0 397.3 0 256S114.7 0 256 0 512 114.7 512 256zM480 256C480 132.8 379.7 32 256 32 132.5 32 32 132.5 32 256S132.5 480 256 480 480 379.5 480 256zM160.9 124.6L247.8 161.7 210.7 248.6 123.8 211.5 160.9 124.6zM270.9 293.7L317.5 387.7H302.9L252.9 287.7 204 387.7H190L241.1 280.8 218.8 271.4 224.8 257.4 293.4 286.5 287.4 300.8 270.9 293.7zM259.1 177.4L327.7 206.8 298.3 275.1 230 246 259.1 177.4zM339.4 220.3L394 243.4 370.6 297.7 316.3 274.6 339.4 220.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpexplorer.js
// module id = YWaP
// module chunks = 144